export class TotalizadorGrafico {

    categorias: any[] = [];
    marcas: any[] = [];

    public processar(marcas: any[]) {
        marcas.forEach(element => {
            
                this.criarCategoria(element.dados, element.id);
                this.marcas = marcas[0].marca;
           
        });
    }

    private criarCategoria(dados: any[], marca: number) {
        dados.forEach(item => {
            let categoria: any;

            const index = this.categorias.findIndex((element) => element.id === item.id);

            if (index >= 0) {
                categoria = this.categorias[index];
            } else {
                categoria = {};

                categoria.id = item.id;
                categoria.nome = item.nome;
                categoria.interna = item.interna;
                categoria.valor_marca = 0;

                this.categorias.push(categoria);
            }
            categoria.valor_marca = item.faturamento;
        });
    }

    public getLabels(): string[] {
        const labels: string[] = [];
        this.categorias.forEach(item => {
            labels.push(item.nome);
        });
        return labels;
    }

    public getDados(): any[] {
        const dados: any[] = [];
        dados.push(this.valoresMarca());  
       return dados;
   }


   private valoresMarca(): any {
       const dados: any = {};
       dados.label = this.marcas;
       dados.data = [];
       this.categorias.forEach(item => {
           dados.data.push(item.valor_marca.toFixed(2));
       });

       return dados;
   }


    public getColors(): any[] {
        return [
                {
                    backgroundColor: 'rgb(0,123,255)',
                    borderColor: 'rgb(5, 105, 126)'
                },
               ];
    }

    public getTipo(): string {
        return 'bar';
    }

    public getLegenda(): boolean {
        return true;
    }
}
